import { api } from 'src/api'

const createPreferences = async dataPreferences => {
  const response = await api.post('/mercadopago/preferences', dataPreferences)
  return response.data
}

export const PrefApi = { createPreferences }
